<ng-container [formGroup]="formGroupAddress">
    <fui-tandem-field>
        <wbo-text-edit-control formControlName="street" [(ngModel)]="address.street" [readonly]="readonly"
                               [label]="'wbo.address.edit.field.street.label'"
                               [placeholder]="'wbo.address.edit.field.street.placeholder'"></wbo-text-edit-control>
        <wbo-text-edit-control formControlName="city" [(ngModel)]="address.city" [readonly]="readonly"
                               [label]="'wbo.address.edit.field.city.label'"
                               [placeholder]="'wbo.address.edit.field.city.placeholder'"></wbo-text-edit-control>
    </fui-tandem-field>
    <fui-tandem-field>
        <wbo-text-edit-control formControlName="state" [(ngModel)]="address.state" [readonly]="readonly"
                               [label]="'wbo.address.edit.field.state.label'"
                               [placeholder]="'wbo.address.edit.field.state.placeholder'"></wbo-text-edit-control>
        <wbo-text-edit-control formControlName="postCode" [(ngModel)]="address.postCode" [readonly]="readonly"
                               [label]="'wbo.address.edit.field.postCode.label'"
                               [placeholder]="'wbo.address.edit.field.postCode.placeholder'"></wbo-text-edit-control>
    </fui-tandem-field>
    <wbo-country-single-select-edit-control formControlName="country" *ngIf="showCountry" [(ngModel)]="address.country"
                                            [readonly]="readonly" [label]="'wbo.address.edit.field.country.label'"
                                            [placeholder]="'wbo.address.edit.field.country.placeholder'"></wbo-country-single-select-edit-control>
</ng-container>
